export interface IAccount {
  accountId: string;
  accountName: string;
}

export type Brand = 'ClonoSEQ' | 'ImmunoSEQ';

export interface IAccountProject {
  accountId: string;
  accountName: string;
  projectId: string;
  projectName: string;
  reportNumberPrefix: string;
  timezone: string;
  workspace: string;
  brand: Brand;
  hasSampleLevelDocuments: boolean;
  customProperties?: ICustomProjectProperties;
}

export enum NavigationTabType {
  ORDERS = 'Orders',
  RESULTS = 'Results',
  UPLOAD = 'Upload',
  HELP = 'Help',
  FILES = 'Files',
}

export interface ICustomProjectProperties {
  brandImage?: string;
  tabs?: NavigationTabType[];
}
export interface IAccountsProjects {
  account: IAccount;
  projects: IAccountProject[];
}

export interface IAccountProjectPickerFormat {
  activeAccountProjects: IAccountsProjects;
  inactiveAccountProjects: IAccountsProjects;
}

export enum Themes {
  ClonoSEQ = 'clonoseq-theme',
  ImmunoSEQ = 'immunoseq-theme',
  Adaptive = 'adaptive-theme',
}

export enum ProjectPickerStorageKeys {
  lastUsedAccountId = 'lastUsedAccountId',
  lastUsedProjectId = 'lastUsedProjectId',
  lastUsedProjectHistory = 'lastUsedProjectHistoricalList',
}

export type typeThemeKeys = keyof typeof Themes;
